import isInPosDevice from "./isInPosDevice"

const isPcPosPaymentRequest = (cashTypes = []) => {
  const isPcPosPaymentSelected =
    cashTypes.some(cashType =>
      cashType.isTerminal &&
      cashType.terminalName === "pcPos"
    )

  return !isInPosDevice() && isPcPosPaymentSelected
}

export default isPcPosPaymentRequest